/* ✅ 1. SMOOTH SCROLL LOGIC */
$(document).on('click', 'a[href^="#"]', function (e) {
  var target = this.hash;
  if (!target) return;

  var $target = $(target);
  if (!$target.length) return;

  e.preventDefault();

  var isMobile = window.innerWidth < 1024;

  // Force Close Menu if open
  if (isMobile && $('.sf-menu-wrapper').is(':visible')) {
    $('.sf-menu-wrapper').addClass('hidden');
    $('body').removeClass('overflow-hidden');
  }

  setTimeout(function () {
    $('html, body').animate(
      {
        scrollTop: $target.offset().top - 100
      },
      800
    );
  }, isMobile ? 450 : 0);
});

/* ✅ 2. MOBILE MENU CLOSE BUTTON LOGIC (FIXED) */
$(document).on('click', '.sf-close-mobile-menu', function (e) {
  e.preventDefault();
  
  // Method 1: Try Standard Theme Close
  $('.sf-header__overlay').trigger('click');

  // Method 2: FORCE CLOSE (Aggressive Fallback)
  // This immediately hides the menu if Method 1 fails
  setTimeout(function(){
      $('.sf-menu-wrapper-mobile').addClass('hidden');
      $('body').removeClass('overflow-hidden'); // Re-enable scrolling on body
  }, 100);
});